import { getStore } from '@/store'
import { EMPTIES_TRANSPORTATIONS, mapTransportType, TransportationTypes } from '@/utils/transportTypes'

export function isWhsUser (): boolean {
  return localStorage.getItem('customertype') === 'WHSL'
}

export function isPosUser (): boolean {
  return localStorage.getItem('customertype') === 'POS'
}

export function showSuggestedCart (): boolean {
  const ArrayPermis = getStore()?.state.auth.user.permissionSchema ?? []
  const shipToId = localStorage.getItem('shipToId')
  const permissionScheme = ArrayPermis.find((item: any) => item.shipToId === shipToId)
  const isEligibleForSuggestedCart = !!permissionScheme?.rpDetails?.some((rp: any) => {
    const permissions = rp.permission?.split(',').map((p: string) => p.trim()) || []
    const isPOSWithMyOrders =
    rp.customerType === 'POS' && permissions.includes('Suggested Cart')
    const isWHSLWithSuggestedCart =
    rp.customerType === 'WHSL' &&
    (rp.rolename === 'WHS Suggested Cart' || permissions.includes('Suggested Cart'))
    return isPOSWithMyOrders || isWHSLWithSuggestedCart
  })

  const suggestedCarts = getStore()?.state.basket.suggestedCarts
  const shipmentId = getStore()?.state.basket.shipmentId ?? localStorage.getItem('shippingMethod') ?? ''
  const hasSuggestedCart =
  Array.isArray(suggestedCarts) && suggestedCarts.length >= 0
  const transportTypes = localStorage.getItem('shippingMethod')
  const isTransportValid = !EMPTIES_TRANSPORTATIONS.includes(mapTransportType(shipmentId))
  const result = hasSuggestedCart && isTransportValid && isEligibleForSuggestedCart && shipmentId !== TransportationTypes.UNFILTERED && shipmentId !== TransportationTypes.TANK && transportTypes !== TransportationTypes.POSM && shipmentId !== TransportationTypes.POSM

  return result
}

export function hasPOSMOrder (): boolean {
  const ArrayPermis = getStore()?.state.auth.user.permissionSchema ?? []
  const shipToId = localStorage.getItem('shipToId')

  const permissionScheme = ArrayPermis.find((item: any) => item.shipToId === shipToId)

  const isEligibleForPOSMOrders = !!permissionScheme?.rpDetails?.some(
    (rp: any) =>
      rp.permission?.split(',').map((p: string) => p.trim()).includes('POSM Orders')
  )

  return isEligibleForPOSMOrders
}
